import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/api";

const LINKS = [
  { label: "About", id: "about" },
  { label: "Upcoming Project", id: "project" },
  { label: "Approved Carriers", id: "carriers" },
  { label: "Onboarding", id: "onboarding" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  return (
    <footer className="border-t border-[#0066FF]/15 bg-[#050B16]">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="rounded-lg bg-white px-2.5 py-1.5 inline-block">
              <img src="/logo.png" alt="PORTBRIDGE Global" className="h-14 w-auto" />
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
              From global suppliers to U.S. customers. Worldwide supply, import logistics and a
              verified carrier network.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Navigate</p>
            <ul className="mt-4 space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollToId(l.id)}
                    className="text-sm text-slate-400 transition-colors hover:text-[#00F0FF]"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Network</p>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              <li>Dry Van · Reefer · Flatbed</li>
              <li>Approved carriers only</li>
              <li>20,000-load program · from Nov 1</li>
              <li>
                <Link to="/admin" data-testid="footer-admin-link" className="text-slate-600 transition-colors hover:text-slate-400">
                  Admin Portal
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-6 sm:flex-row">
          <p className="text-xs text-slate-600">© {new Date().getFullYear()} PORTBRIDGE Global. All rights reserved.</p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-600">
            From Global Suppliers to U.S. Customers.
          </p>
        </div>
      </div>
    </footer>
  );
}
